import React, { Component } from 'react';
import Header from 'parts/Header';
import CharterHero from 'parts/CharterHero';
import CharterContent from 'parts/CharterContent';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

export default class CharterPortfolioPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <CharterHero />
        <CharterContent />
        <Discuss />
        <Footer />
      </>
    );
  }
}
